<template>
  <main class="flex flex-col h-screen justify-center">
    <router-view />
  </main>
</template>

<script>
export default {
  mounted() {
    this.title = this.$route.meta.prtitle;
    var token = localStorage.getItem("token");
    if (token == null) {
      this.$router.push({ name: "Register" });
    } else if (this.title == "Register" || this.title == "Login") {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>
